import { Platform } from "react-native";
import { VOLT_ERROR_CODE } from "../../configs/constants";
import { getParameters, isEmpty } from "../../configs/utils";
import SharedPropsService from "../../SharedPropsService";
import { generateUtmObject, triggerAmplitudeEventCGS } from "./utils";
import sharedPropsService from "../../SharedPropsService";
import { api } from "../../configs/api";
import { getAuthHeaders } from "../../configs/config";
import { ROUTE } from "../../routes";
export const goBackAction = async (action, _datastore, { navigate }) => {
    const fromRouteId = action?.payload?.routeId;
};
export const onChangeDimension = async (action, _datastore, { navigateToBase }) => {
    console.warn("**** onChangeDimension Action Triggered ****", action);
    const widthX = action.payload.width;
    const heightX = action.payload.height;
    const dimensionData = {
        height: heightX,
        width: widthX
    };
    if (Platform.OS === 'web') {
        window.parent.postMessage({ id: 'getDimensionLeads', data: dimensionData }, '*');
    }
};
export const getStatementCtaAction = async (action, _datastore, { network, navigateWithClear, navigateToBase, instrumentTrack }) => {
    console.warn("**** getStatementCtaAction Action Triggered ****", action);
    const phone = action.payload.phone;
    const pan = action.payload.pan;
    const fromDate = action.payload.fromDate;
    const toDate = action.payload.toDate;
    const unique_id = action.payload.unique_id;
    const isResend = action.payload.isResend ? action.payload.isResend : false;
    triggerAmplitudeEventCGS(instrumentTrack, {
        eventName: 'CGS_GET_STATEMENT_CTA_CLICKED'
    });
    await SharedPropsService.setCgtcUserContext({
        pan: pan,
        phone: phone,
        toDate: toDate,
        fromDate: fromDate,
    });
    const refUrl = getParameters(window.location.href);
    const ref = refUrl.ref;
    const sourceQuery = refUrl.source;
    const partnerAccountID = refUrl?.partnerAccountId;
    const createUtmObject = await generateUtmObject();
    let registerLeadBody = {
        phoneNumber: phone,
        pan: pan,
        leadTrackingDetails: createUtmObject,
        ...partnerAccountID && {
            partnerAccountId: partnerAccountID
        },
        source: sourceQuery ? sourceQuery : 'MARKETING_MFC_CGS',
    };
    if (!isEmpty(createUtmObject)) {
        registerLeadBody = {
            ...registerLeadBody,
            leadTrackingDetails: createUtmObject
        };
    }
    //call Register leads
    let registerLeadResponse;
    if (!isResend) {
        registerLeadResponse = await network.post(`${api.RegisterALead}`, registerLeadBody, {
            headers: await getAuthHeaders()
        }, async () => { return; }, { isPartnerPlatform: true, });
    }
    if (isResend ||
        registerLeadResponse?.status === 200) {
        const leadId = isResend
            ? action?.payload?.leadId
            : registerLeadResponse?.data?.leadId;
        console.log('registerLeadResponse: ', registerLeadResponse);
        const mfcCgsDetailedOTPInitRequestBody = {
            fromDate: fromDate,
            toDate: toDate,
            leadId: leadId,
            panNumber: pan,
            phoneNumber: phone,
            trackingDeviceId: unique_id,
        };
        // Call OTP Init
        const mfcCgsDetailedOTPInitResponse = await network.post(`${api.mfcCgsDetailedOTPInit}`, mfcCgsDetailedOTPInitRequestBody, {
            headers: await getAuthHeaders()
        }, async () => { return; }, { isPartnerPlatform: true });
        if (mfcCgsDetailedOTPInitResponse.status === 200) {
            const cgstUserContext = await sharedPropsService.getCgtcUserContext();
            await sharedPropsService.setCgtcUserContext({
                ...cgstUserContext,
                leadId: leadId,
                toDate: toDate,
                fromDate: fromDate,
                otpData: {
                    reqId: mfcCgsDetailedOTPInitResponse?.data?.reqId,
                    otpRef: mfcCgsDetailedOTPInitResponse?.data?.otpRef,
                    userSubjectReference: mfcCgsDetailedOTPInitResponse?.data?.userSubjectReference,
                    clientRefNo: mfcCgsDetailedOTPInitResponse?.data?.clientRefNo,
                }
            });
            //navigate to OTP Page
            await navigateWithClear(ROUTE.CGTC_OTP, {});
        }
        else if (mfcCgsDetailedOTPInitResponse.response?.status === 400) {
            if (mfcCgsDetailedOTPInitResponse.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PORTFOLIO_NOT_FOUND) {
                navigateToBase(ROUTE.CGTC_NO_PORTFOLIO);
            }
        }
    }
};
export const amplitudeEventPan = async (action, _datastore, { instrumentTrack }) => {
    console.warn('*** amplitudeEventPan ***');
    // await triggerAmplitudeEventCGS(
    //     instrumentTrack,
    //     {
    //         eventName: 'CGS_PAN_ENTERED'
    //     }
    // )
};
export const amplitudeEventPhone = async (action, _datastore, { instrumentTrack }) => {
    console.warn('*** amplitudeEventPhone ***');
    // await triggerAmplitudeEventCGS(
    //     instrumentTrack,
    //     {
    //         eventName: 'CGS_MOBILE_ENTERED'
    //     }
    // )
};
export const amplitudeEventFinancialYear = async (action, _datastore, { instrumentTrack }) => {
    console.warn('*** amplitudeEventFinancialYear ***');
    // await triggerAmplitudeEventCGS(
    //     instrumentTrack,
    //     {
    //         eventName: 'CGS_FY_ENTERED'
    //     }
    // )
};
export const amplitudeEventTermsAndCondition = async (action, _datastore, { instrumentTrack }) => {
    console.warn('*** amplitudeEventTermsAndCondition ***');
    await triggerAmplitudeEventCGS(instrumentTrack, {
        eventName: 'CGS_TC_CLICKED'
    });
};
export const amplitudeEventPrivacy = async (action, _datastore, { instrumentTrack }) => {
    console.warn('*** amplitudeEventPrivacy ***');
    await triggerAmplitudeEventCGS(instrumentTrack, {
        eventName: 'CGS_PRIVACY_POLICY_CLICKED'
    });
};
export const amplitudeEventGetStatement = async (action, _datastore, { instrumentTrack }) => {
    console.warn('*** amplitudeEventGetStatement ***');
    await triggerAmplitudeEventCGS(instrumentTrack, {
        eventName: 'CGS_GET_STATEMENT_CTA_CLICKED'
    });
    await triggerAmplitudeEventCGS(instrumentTrack, {
        eventName: 'CGS_GET_STATEMENT_CTA_CLICKED'
    });
};
